<template>
  <div class="notfound-container">
    <img :src="notfound">
    <h1>要访问的页面不存在</h1>
    <el-button type="primary" round @click="$router.replace('/')">返回首页</el-button>
  </div>
</template>

<script>
import notfound from '@/assets/images/404.svg';
export default {
  name: 'NotFound',
  data() {
    return {
      notfound
    }
  }
}
</script>

<style lang="less" scoped>
.notfound-container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 800px;
    margin: -100px auto;
    display: block;
  }
  h1 {
    margin-bottom: 20px;
    color: var(--secondary-text-color);
  }
}
</style>
